import { Loader2 } from 'lucide-react';

import type { TrialConversionResponse } from '~entities/dashboard/api/get-trial-conversion';

import {
  formatTrialConversionDetail,
  formatTrialConversionRate,
} from '~features/new-dashboard/helpers/format-trial-conversion';

type TrialConversionSummaryVariant = 'banner' | 'inline' | 'detail';

interface TrialConversionSummaryProps {
  metrics?: TrialConversionResponse | null;
  isLoading?: boolean;
  variant?: TrialConversionSummaryVariant;
  label?: string;
  className?: string;
}

export function TrialConversionSummary({
  metrics,
  isLoading = false,
  variant = 'inline',
  label,
  className,
}: TrialConversionSummaryProps) {
  if (isLoading) {
    return (
      <span
        className={`flex items-center gap-2 text-muted-foreground ${className ?? ''}`}
      >
        <Loader2 className='size-4 animate-spin' />
        {variant === 'detail' ? 'Loading conversion summary…' : null}
      </span>
    );
  }

  const text =
    variant === 'detail'
      ? formatTrialConversionDetail(metrics)
      : formatTrialConversionRate(metrics);

  if (variant === 'banner') {
    return <>{text}</>;
  }

  if (variant === 'detail') {
    return (
      <p className={className}>
        <span className='font-semibold'>{label ?? 'Trial conversion'}:</span>{' '}
        {text}
      </p>
    );
  }

  return (
    <p className={`text-sm text-muted-foreground ${className ?? ''}`}>
      {label ?? 'Trial conversion this week'}:{' '}
      <span className='font-semibold text-foreground'>{text}</span>
    </p>
  );
}
